import { useMemo } from 'react';
import { generatePath, useHistory } from 'react-router-dom';
import DownFilled from '@distribusion/portal-icons/dist/DownFilled';
import UserFilled from '@distribusion/portal-icons/dist/UserFilled';
import { OryAuth, useDemoMode, useSession } from '@distribusion/portal-lib/auth';
import { Flex, Text } from '@distribusion/portal-lib/components';
import { useBreakpoint } from '@distribusion/portal-lib/responsive';
import { insertIf } from '@distribusion/portal-lib/utils';
import { Avatar, Button, Dropdown } from 'antd';
import { ItemType, MenuDividerType } from 'antd/es/menu/hooks/useItems';
import { ROUTES } from 'constants/common';
import { useTranslation } from 'lib/translation';

import { DemoSwitch } from '../demo-switch';

export const ProfileMenu = () => {
  const { shouldShowDemoSwitch } = useDemoMode();
  const { t } = useTranslation();
  const { lg } = useBreakpoint();
  const history = useHistory();
  const { data } = useSession();

  const userName = useMemo(() => {
    const { identity } = data || {};
    if (identity) {
      return `${identity.traits.first_name} ${identity.traits.last_name}`;
    }
    return '';
  }, [data]);

  const menuItems = useMemo<ItemType[]>(
    () => [
      {
        key: 'profile',
        label: t('profile_menu_items.profile'),
        onClick: () => history.push(generatePath(ROUTES.USERS.DETAIL, { id: data?.identity?.id })),
      },
      ...insertIf(!lg && shouldShowDemoSwitch, {
        type: 'divider',
      } as MenuDividerType),
      ...insertIf(!lg && shouldShowDemoSwitch, {
        key: 'demo-mode',
        label: <DemoSwitch textSize="md" />,
      }),
      {
        type: 'divider',
      },
      {
        key: 'logout',
        label: t('profile_menu_items.logout'),
        onClick: () => OryAuth.logout(),
      },
    ],
    [data?.identity?.id, history, lg, shouldShowDemoSwitch, t],
  );

  return (
    <Dropdown
      menu={{ items: menuItems }}
      trigger={['click']}
      // It doesn't support setting `min-width` using className
      overlayStyle={!lg ? { minWidth: '140px' } : undefined}
    >
      <Button type="text" size="large" data-testid="profile-menu" style={{ height: 'unset' }}>
        <Flex gap="middle" align="center">
          <Avatar icon={<UserFilled />} />
          {lg && (
            <>
              <Text>{userName}</Text>
              <DownFilled />
            </>
          )}
        </Flex>
      </Button>
    </Dropdown>
  );
};
